import { AppRoutes } from "./app-routes";

export const RedirectRules = {
  Root: {
    from: "/",
    to: AppRoutes.Main,
  },
} as const;
